import React, { useContext, } from 'react'
import { Segment, Dropdown, Divider, Header } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite'
import { RootStoreContext } from '../../../../../App/stores/RootStore'
import { reviewResults } from '../../../../../App/enumerable/ReviewResults';

const RequestReviewMakeDetermination = () => {
    const rootStore = useContext(RootStoreContext);

    const { setReviewResult, ValidationResult } = rootStore.requestReviewStore;
    const { closeModal } = rootStore.modalStore;

    const getReviewResultsOptions = () => {
        var SelectedReviewResults: {
            key: string;
            text: string;
            value: string;
        }[] = [];

        ValidationResult?.recomendedResults.forEach(element => {
            var reviewResult = reviewResults.find(el => el.key === element);
            if (reviewResult) {
                SelectedReviewResults.push(
                    reviewResult
                )
            }
        });

        return SelectedReviewResults;
    }

    //TODO: Typescriptify this
    const handleDropdown = (event: any, data: any) => {
        if (data.value) {
            var val: string = data.value
            setReviewResult(val);
            closeModal();
        }
    };

    return (
        <Segment clearing>
            <Header>Make a Review Determination</Header>

            <Divider />

            <Dropdown
                placeholder='Select Review Result'
                fluid
                selection
                options={getReviewResultsOptions()}
                onLabelClick={handleDropdown}
                onChange={handleDropdown}
                onClick={handleDropdown}
            />
        </Segment>

    );
}
export default observer(RequestReviewMakeDetermination);